export const ApiErrorLogger = (error: unknown): void => console.error('APIError', error);
